import { platformSite } from '../data/http';
import { SearchIcon } from '../icons';

/* ИЗБРАННЫЕ ВРАЧИ. Раздел из макета, ручки НЕТ ВООБЩЕ — «избранное» не хранится
   нигде: ни таблицы, ни ручки, ни в одном сервисе.

   Что понадобится, когда дойдут руки: связь «аккаунт ↔ врач» и пара ручек.
   Наполняется список двумя способами, и в макете названы оба — автоматически
   после визита и вручную со страницы специалиста.

   Выдуманных врачей здесь больше нет по той же причине, что и выдуманных визитов
   (см. `Visits.tsx`): подпись «данные из макета» не защищает — пациент читает
   имена и адреса как свои. */

export function Doctors() {
    // Нет адреса публичных страниц — нет и кнопки; см. `Visits.tsx`.
    const site = platformSite();
    return (
        <>
            <div className="mh">
                <div>
                    <h1>Избранные врачи</h1>
                    <div className="sub">специалисты, у которых вы были или добавили в избранное</div>
                </div>
                {site !== null && (
                    <div className="act">
                        <a className="btn" href={site}>
                            <SearchIcon />
                            найти врача
                        </a>
                    </div>
                )}
            </div>

            <div className="cols">
                <div>
                    <div className="empty">
                        Избранное сюда пока не подключено. Найти специалиста и записаться можно на
                        публичных страницах врачей — кнопка выше.
                    </div>
                    <p className="fine">
                        Позже врачи будут попадать в этот список после визита или вручную со страницы
                        специалиста.
                    </p>
                </div>
            </div>
        </>
    );
}
